import myRuleProvider from './myRuleProvider'

export default  {
    __init__: [
      'myRuleProvider'
    ],
    myRuleProvider: [ 'type', myRuleProvider ]
};
